import React from 'react'

const NormalDissatisfied = () => {
  return (
    <div>
   <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 14 14" fill="none">
<path d="M6.99414 1.1665C10.2199 1.1665 12.8338 3.77966 12.834 6.99951C12.834 10.2195 10.22 12.8335 6.99414 12.8335C3.7743 12.8333 1.16699 10.2194 1.16699 6.99951C1.16717 3.77978 3.77441 1.16669 6.99414 1.1665ZM7 2.3335C4.42192 2.33367 2.33416 4.42144 2.33398 6.99951C2.33398 9.57774 4.42182 11.6663 7 11.6665C9.57833 11.6665 11.667 9.57785 11.667 6.99951C11.6668 4.42133 9.57822 2.3335 7 2.3335ZM8.75 8.1665V9.0415H5.25V8.1665H8.75ZM4.95898 4.6665C5.44208 4.66668 5.83398 5.05836 5.83398 5.5415C5.83398 6.02464 5.44208 6.41633 4.95898 6.4165C4.47574 6.4165 4.08398 6.02475 4.08398 5.5415C4.08398 5.05825 4.47574 4.6665 4.95898 4.6665ZM9.04199 4.6665C9.52524 4.6665 9.91699 5.05825 9.91699 5.5415C9.91699 6.02475 9.52524 6.4165 9.04199 6.4165C8.55874 6.4165 8.16699 6.02475 8.16699 5.5415C8.16699 5.05825 8.55874 4.6665 9.04199 4.6665Z" fill="black" fill-opacity="0.54"/>
</svg>
    </div>
  )
}

export default NormalDissatisfied
